module.exports = __webpack_public_path__ + "img/73_11.652b011e.png";